import type { QueryClient } from '@tanstack/react-query';
import { createRealtimeClient } from '@projexn/tenant-store/client';

// Wire the tenant DO's WebSocket invalidations to TanStack Query's cache.
// Channel name == React Query key prefix. The wildcard handler also bumps
// a `realtimeState` field so the AppShell can show a connection indicator.

export function startRealtime(
  queryClient: QueryClient,
  onState?: (state: 'connecting' | 'open' | 'closed' | 'reconnecting') => void,
): () => void {
  const url = `${window.location.origin.replace(/^http/, 'ws')}/api/realtime`;
  const rt = createRealtimeClient(url, { onStateChange: onState });
  const off = rt.on('*', (msg) => {
    queryClient.invalidateQueries({ queryKey: [msg.channel] });
  });
  return () => {
    off();
    rt.close();
  };
}
